
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      
      <main className="flex-grow pt-32 pb-20">
        <div className="container-width">
          <h1 className="h1 mb-8">Terms and Conditions</h1>
          
          <div className="prose max-w-none">
            <p>Last updated: July 15, 2024</p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. Booking with Thys Gemaak Spitbraai Catering</h2>
            <p>
              a) All bookings must be confirmed in writing by the Client via WhatsApp: +27 60 461 3766 or
              email: info@thysgemaak.com.
            </p>
            <p>
              b) A non-refundable booking fee of R500 is required to secure Thys Gemaak Spitbraai Catering
              for the date of your event.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. Booking Deposit</h2>
            <p>
              a) A booking deposit amount will be provided to the Client in writing by Thys Gemaak Spitbraai
              Catering once your booking confirmation is received. This deposit will be deducted from the
              total costs.
            </p>
            <p>
              b) Payment must be made via EFT bank transfer. (Banking details below)
            </p>
            <p>
              c) A 50% Deposit is payable 14 days prior to the event.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. Booking Confirmation</h2>
            <p>
              a) Once the client's deposit/s have been received a receipt will be issued by Thys Gemaak
              Spitbraai Catering together with a formal confirmation letter which will include your draft
              menu, event summary and estimated costs based on the number of guests and locations made
              by the Client.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Payment of Total Event Costs</h2>
            <p>
              a) Payment in full is required for all catering services to be provided by Thys Gemaak Spitbraai
              Catering.
            </p>
            <p>
              b) The full quoted amount must therefore be settled 2 days prior to the event and the R500 booking
              fee is deducted from the total amount due.
            </p>
            <p>
              c) Final guest numbers must be confirmed to Thys Gemaak Spitbraai Catering when the deposit
              is paid 14 days prior to your event.
            </p>
            <p>
              d) The information provided at this point will be used to produce your event cost invoice, arrange
              staff and co-ordinate with yourselves. Once our invoice is received by the Client payment must
              be received no later than 2 days prior to the event.
            </p>
            <p>
              e) After final numbers have been provided to Thys Gemaak Spitbraai Catering, we are happy to
              accept any increases in requirements however no reduction will be possible.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">5. Cancellation Charge</h2>
            <p>
              a) In the unfortunate event of a booking having to be cancelled, confirmation in writing will be
              needed by the Thys Gemaak Spitbraai Catering and your deposit will be retained.
            </p>
            <p className="mt-4">
              Cancellation policies:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Cancellations made 30 days or more before the event date: 50% of the total amount will be refunded (excluding the deposit)</li>
              <li>Cancellations made 14-29 days before the event date: 25% of the total amount will be refunded (excluding the deposit)</li>
              <li>Cancellations made less than 14 days before the event date: No refund will be provided</li>
            </ul>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">6. Dietary Requirements and Allergies</h2>
            <p>
              a) Thys Gemaak Spitbraai Catering will endeavour to provide suitable adaptions to the Client's
              menu for any guests with special dietary requirements or allergies. We cannot however take
              responsibility for any guests unless advised in advance (no less than 48 hours prior to the event).
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">7. Clients Food and Drinks</h2>
            <p>
              a) We accept no liability for any food supplied to the Client by another caterer (or food products
              suppliers by the Client themselves) in additional to those arranged by Thys Gemaak Spitbraai
              Catering.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">8. Client's use of Thys Gemaak Spitbraai Catering's Property and Clients Personal Property</h2>
            <p>
              a) The Client agrees to pay for any loss or damage to any equipment, crockery, cutlery or
              glassware supplied by Thys Gemaak Spitbraai Catering for the event, including any issues
              caused by the Clients crew/group or guests.
            </p>
            <p>
              b) Thys Gemaak Spitbraai Catering will not be held responsible for the theft, lost or damage to
              any personal effects of the Client or Clients crew, group or guests.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">9. Liability of Thys Gemaak Spitbraai Catering</h2>
            <p>
              a) Thys Gemaak Spitbraai Catering accept no liability under any claim whatsoever arising (be it
              by negligence or otherwise) for any loss over the figure of the existing Thys Gemaak Spitbraai
              Catering Public Liability Limit of Indemnity. Note that this figure which may change from time
              to time and is available upon request together with a copy of our Certificate.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">10. Force Majeure</h2>
            <p>
              a) Thys Gemaak Spitbraai Catering shall incur no liability to the Client if performance of the
              contract is prevented or hindered by any case whatsoever beyond Thys Gemaak Spitbraai
              Catering's control and in particular but without prejudice to the generality of the foregoing, by
              act of fire, flood, subsidence, sabotage, accident, strike, or lock out and shall not be liable for
              any loss or damage resulting there from suffered by the Client.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">11. Special Dietary requirements and Allergies</h2>
            <p>
              a) The client must indicate to Thys Gemaak Spitbraai Catering of any special or specific dietary
              requirements no later than 7 days prior to the event. Thys Gemaak Spitbraai Catering will asume
              that the Client does not have any special dietary requirements, should the Client fail to indicate
              so seven days prior to the event.
            </p>
            <p>
              b) The client must indicate this in writting to Thys Gemaak Spitbraai Catering within the specified
              period indicated.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">12. Banking Details</h2>
            <p>
              a) Payments must be made via Bank EFT to:
            </p>
            <p className="ml-4 mt-2">
              <strong>Capitec Business Bank</strong><br />
              Thys Gemaak SDC<br />
              Transact Account<br />
              Acc no. 1051789869<br />
              Branch Code: 470010<br />
              Reference: Client's surname and date of function
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">13. Acceptance of the terms and conditions</h2>
            <p>
              a) By submitting a booking inquiry, the client accepts all the terms and conditions as stipulated above.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">14. Contact Us</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <p className="mt-4">
              <strong>Email:</strong> spitbookings@thysgemaak.com<br />
              <strong>Phone:</strong> +27 60 461 3766<br />
              <strong>Address:</strong> 75 School Street, Kylemore, Stellenbosch, 7600
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsOfService;
